import {
  CheckboxVisibility,
  DetailsList,
  Dropdown,
  IColumn,
  IContextualMenuItem,
  IDetailsRowProps,
  Label,
  PrimaryButton,
  SearchBox,
  Stack,
  TextField,
} from '@fluentui/react';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Paging from '../../../control/paging';
import ModalComponentModel from './modal/modalComponentModel';
import useToken from '../../account/login/useToken';
import * as Api from '../../../api/src';
import ButtonMenuContext from '../../../control/ButtonMenuContext';
import { _renderRow } from '../../../control/function/detailList';
import '../../../css/controll/buttonMenuContext.scss';
import { commonfn } from '../../../common/commonfn';
import { DialogContext } from '../../../context/dialog.context';
import { NoDataFound } from '../../../control/noDataFound';
import { LeftMenuContext } from '../../../context/leftMenu.context';
import { StatusItem } from '../../../control/statusItem';
import { Loading } from '../../../control/loading';

const ComponentsApi = new Api.ComponentsApi();
const ProductTypesApi = new Api.ProductTypesApi();
let FilterQueryCache = {
  Page: 1,
  PageSize: 20,
  ProductTypeId: 0,
  ComponentId: 0,
  CBrandId: 0
} as Api.CModelPagingRequestModel | null;
const Models = () => {
  const { setMsgConfirmDialog, setCallBackConfirmDialog, setTitleDialog } = React.useContext(DialogContext);
  const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
  const { t } = useTranslation();
  const [FilterQuery, setFilterQuery] = React.useState<Api.CModelPagingRequestModel>({
    Page: 1,
    PageSize: 20,
    ProductTypeId: 0,
    ComponentId: 0,
    CBrandId: 0
  });
  const [listMaster, setMaster] = React.useState<Api.ComponentPaginatedResult | null>(null);
  const [listProductType, setListProductType] = React.useState<any[]>([]);
  const [listComponent, setListComponent] = React.useState<any[]>([]);
  const [listBrand, setListBrand] = React.useState<any[]>([]);
  const [listComponentFilter, setListComponentFilter] = React.useState<any[]>([]);
  const [listBrandFilter, setListBrandFilter] = React.useState<any[]>([]);
  const [itemSelected, SetItemSelected] = React.useState<Api.CModelModel | null>(null);
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isShowLoading, SetIsShowLoading] = React.useState(true);

  const _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.CModelModel) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Edit',
            text: t('Edit'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsOpenModal(true);
            },
          },
          {
            key: 'Delete',
            text: t('Delete'),
            onClick: (ev) => {
              setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
              setCallBackConfirmDialog({ action: deleteItem, param: item.Id });
            },
          },
        ];
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'Name',
      name: t('Name'),
      fieldName: 'Name',
      isResizable: true,
      className: 'flex-center',
    },
    {
      key: 'Brand',
      name: t('Brand'),
      fieldName: 'CBrandName',
      isResizable: true,
      minWidth: 300,
      maxWidth: 300,
      className: 'flex-center',
    },
    {
      key: 'Component',
      name: t('Component'),
      fieldName: 'ComponentName',
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
      className: 'flex-center',
    },
    {
      key: 'Status',
      name: t('Status'),
      className: 'flex-center',
      minWidth: 200,
      maxWidth: 200,
      onRender: (item: Api.CModelModel) => {
        return (
          <StatusItem
            Status={item.States || Api.StatesEnum.Inactive}
            Name={t(commonfn.getActiveName(item.States))}
          ></StatusItem>
        );
      },
    },
  ] as IColumn[];
  const [columns, setColumns] = React.useState<IColumn[]>(_columns);

  React.useEffect(() => {
    getAllProductTypes();
    getAllComponents();
    getAllBrands();
    setSelectedMenuItem('Components');
  }, []);

  React.useEffect(() => {
    filterComponents();
    filterBrands();
  }, [FilterQuery.ProductTypeId, FilterQuery.ComponentId]);

  const getList = async () => {
    SetIsShowLoading(true);
    let data = (await ComponentsApi.getCModels(FilterQuery)).data;
    setMaster(data);
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };
  const deleteItem = async (id: number) => {
    await ComponentsApi.removeCModel(id);
    setFilterQuery({ ...FilterQueryCache, Page: 1 });
  };
  const getAllProductTypes = async () => {
    let data = (
      await ProductTypesApi.apiProductTypesPagedPost({
        PageNumber: 0,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let productTypes: any[] = [{ key: 0, text: t('AllProductTypes') }];
    data.Data?.forEach((element) => {
      productTypes.push({ key: element.Id, text: element.Name });
    });
    setListProductType(productTypes);
  };

  const getAllComponents = async () => {
    let data = (
      await ComponentsApi.apiComponentsPagedPost({
        PageNumber: 0,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    setListComponent(data.Data ?? []);

    let components: any[] = [{ key: 0, text: t('AllComponents') }];
    let filters = data.Data?.map((x) => ({ key: x.Id, text: x.Name }));
    if(filters?.length)
      components = [...components, ...filters];
    setListComponentFilter(components);
  };

  const getAllBrands = async () => {
    let data = (
      await ComponentsApi.getCBrands({
        Page: 0,
        PageSize: 0,
        GetOnlyActive: true,
      })
    ).data;
    setListBrand(data.Data ?? []);

    let brands: any[] = [{ key: 0, text: t('AllBrands') }];
    let filterBrands = data.Data?.map((x) => ({ key: x.Id, text: x.Name }));
    if(filterBrands?.length)
      brands = [...brands, ...filterBrands];
    setListBrandFilter(brands);
  };

  const filterBrands = () => {
    let brands: any[] = [{ key: 0, text: t('AllBrands') }];
    let filterBrands = listBrand.filter((x) => (FilterQuery.ProductTypeId === 0 || x.ProductTypeId === FilterQuery.ProductTypeId) 
      && (FilterQuery.ComponentId === 0 || x.ComponentIds.includes(FilterQuery.ComponentId)))
      .map((x) => ({ key: x.Id, text: x.Name }));
    if(filterBrands.length)
      brands = [...brands, ...filterBrands];
    setListBrandFilter(brands);
  }

  const filterComponents = () => {
    let components: any[] = [{ key: 0, text: t('AllComponents') }];
    let filters = listComponent.filter((x) => FilterQuery.ProductTypeId === 0 || x.ProductTypeId === FilterQuery.ProductTypeId)
    .map((x) => ({ key: x.Id, text: x.Name }));
    if(filters.length)
      components = [...components, ...filters];
    setListComponentFilter(components);
  }

  let timeOutGetList: any = null;
  React.useEffect(() => {
    if (FilterQueryCache?.Search != FilterQuery.Search) {
      if (timeOutGetList) {
        clearTimeout(timeOutGetList);
        timeOutGetList = null;
      }
      timeOutGetList = setTimeout(() => {
        getList();
        timeOutGetList = null;
      }, 350);
      FilterQueryCache = FilterQuery;
      return () => window.clearTimeout(timeOutGetList);
    } else {
      getList();
      FilterQueryCache = FilterQuery;
    }
  }, [FilterQuery]);
  const _onColumnClick = (event: MouseEvent<HTMLElement> | undefined, column: IColumn | undefined) => {
    if (column?.name) {
      SetIsShowLoading(true);
      const newColumns: IColumn[] = columns.slice();
      const currColumn: IColumn = newColumns.filter((currCol) => column?.key === currCol.key)[0];
      newColumns.forEach((newCol: IColumn) => {
        if (newCol === currColumn) {
          currColumn.isSortedDescending = !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          newCol.isSorted = false;
          newCol.isSortedDescending = true;
        }
      });

      setFilterQuery({ ...FilterQuery, SortField: column?.key, IsDescending: currColumn.isSortedDescending })
    }
  };
  return (
    <>
      <div className="page-content ">
        <Loading isShow={isShowLoading}></Loading>
        <div className="ms-Grid form-list" dir="ltr">
          <div className="ms-Grid-row display-flex">
            <div className="ms-Grid-col margin-right-auto ms-md2" style={{ minWidth: 200 }}>
              <Dropdown
                options={listProductType}
                selectedKey={FilterQuery.ProductTypeId}
                onChange={(e, option) => {
                  setFilterQuery({ ...FilterQuery, ProductTypeId: option?.key as number, Page: 1, ComponentId: 0, CBrandId: 0 });
                }}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col margin-right-auto ms-md2" style={{ minWidth: 200 }}>
              <Dropdown
                options={listComponentFilter}
                selectedKey={FilterQuery.ComponentId}
                onChange={(e, option) => {
                  setFilterQuery({ ...FilterQuery, ComponentId: option?.key as number, Page: 1, CBrandId: 0 });
                }}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col margin-right-auto ms-md2" style={{ minWidth: 200 }}>
              <Dropdown
                options={listBrandFilter}
                selectedKey={FilterQuery.CBrandId}
                onChange={(e, option) => {
                  setFilterQuery({ ...FilterQuery, CBrandId: option?.key as number, Page: 1 });
                }}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 200 }}>
              <SearchBox
                placeholder={t('Search')}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, Search: newValue || '', Page: 1 });
                }}
              />
            </div>
            <div className="ms-Grid-col ms-sm8  padding-right-0">
              <Stack horizontal className="header-action">
                <PrimaryButton
                  className="margin-left-auto"
                  text={t('New')}
                  onClick={() => {
                    SetIsOpenModal(true);
                    SetItemSelected(null);
                  }}
                />
              </Stack>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listMaster?.Data?.length || 0) > 0 && (
            <DetailsList
              items={listMaster?.Data || []}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              onColumnHeaderClick={_onColumnClick}
              onRenderRow={(props) => {
                return _renderRow(props || ({} as IDetailsRowProps), () => {
                  SetItemSelected(props?.item);
                  SetIsOpenModal(true);
                });
              }}
            />
          )}
          <NoDataFound isShow={listMaster?.Data?.length == 0}></NoDataFound>
          <Paging
            CurrentPage={FilterQuery.Page}
            TotalPage={listMaster?.TotalPages || 0}
            onChangePage={(page, PageSize) => {
              setFilterQuery({ ...FilterQuery, Page: page, PageSize: PageSize });
            }}
          ></Paging>
        </div>
      </div>
      <ModalComponentModel
        IsOpen={isOpenModal}
        Item={itemSelected}
        ProductTypeId={FilterQuery.ProductTypeId || 0}
        ComponentId={FilterQuery.ComponentId || 0}
        CBrandId={FilterQuery.CBrandId || 0}
        onSaveClick={() => {
          setFilterQuery({ ...FilterQuery, Page: 1 });
        }}
        onCloseModal={() => {
          SetIsOpenModal(false);
        }}
      ></ModalComponentModel>
    </>
  );
};
export default Models;
